export interface IState {
  invoicesList: any;
  inventroyCount: any;
  invoiceDetails: any;
  nonInvoiceWordOrder: any;
  depositeAmount: any;
  invoiceDetailsForPay: any;
  invoicesReviewDataList: any;
  requestCount: any;
  pendingApprovalCount: any;
}

type Action = any;

export const InvoicesReducer = (
  state: IState = {
    invoicesList: [],
    inventroyCount: 0,
    invoiceDetails: null,
    nonInvoiceWordOrder: [],
    depositeAmount: 0,
    invoiceDetailsForPay: null,
    invoicesReviewDataList: [],
    requestCount: 0,
    pendingApprovalCount: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_INVOICES_DATA":
      return {
        ...state,
        invoicesList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.invoicesList, ...action?.payload?.data],
        inventroyCount: action?.payload?.count,
        requestCount: action?.payload?.requestCount,
      };
    case "GET_INVOICES_DETAILS_DATA":
      return {
        ...state,
        invoiceDetails: action?.payload,
      };
    case "CHNAGE_REVIEWER_STATUS":
      const updatedUser = state?.invoiceDetails?.review?.map((elem: any) => {
        if (elem?.user_id?._id == action?.payload?.userId) {
          return { ...elem, status: 2 };
        }
        return elem;
      });

      return {
        ...state,
        invoiceDetails:
          state?.invoiceDetails?._id == action?.payload?.id
            ? { ...state?.invoiceDetails, review: updatedUser }
            : state?.invoiceDetails,
      };
    case "GET_WORK_NON_INVOICE_ORDERS":
      return {
        ...state,
        nonInvoiceWordOrder: action?.payload,
      };
    case "GET_DEPOSITE_AMOUNT":
      return {
        ...state,
        depositeAmount: action?.payload,
      };
    case "GET_INVOICES_DETAILS_DATA_FRO_CLIENT":
      return {
        ...state,
        invoiceDetailsForPay: action?.payload,
      };
    case "GET_REVIEW_INVOICES_DATA":
      return {
        ...state,
        invoicesReviewDataList:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.invoicesReviewDataList, ...action?.payload?.data],
        pendingApprovalCount: action?.payload?.count,
      };
    case "CLEAR_DEPOSITE_AMOUNT":
      return {
        ...state,
        depositeAmount: 0,
      };
    case "COMPLETE_NON_INVOICE_WORK_ORDER":
      return {
        ...state,
        nonInvoiceWordOrder: state?.nonInvoiceWordOrder?.filter((elem: any) => elem?._id != action?.payload?.wo_id),
      };
    default:
      return state;
  }
};
